/**
 * Tailwind's dark variant matches .dark on an ancestor. The class must live on
 * document.documentElement (<html>), not <body>, so the whole app (including
 * inherited colors) responds consistently when the user picks Light / Dark / System.
 */
export function resolveShouldBeDark(theme) {
    if (typeof window === 'undefined') {
        return true;
    }

    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    return theme === 'system' ? prefersDark : theme === 'dark';
}

export function applyColorScheme(theme) {
    if (typeof document === 'undefined') {
        return;
    }

    const shouldBeDark = resolveShouldBeDark(theme);

    document.documentElement.classList.toggle('dark', shouldBeDark);
}

/**
 * Apply only if the resolved scheme differs from the current <html> class (no-op otherwise).
 */
export function applyColorSchemeIfNeeded(theme) {
    if (typeof document === 'undefined') {
        return;
    }

    const shouldBeDark = resolveShouldBeDark(theme);
    const isDark = document.documentElement.classList.contains('dark');

    if (shouldBeDark !== isDark) {
        document.documentElement.classList.toggle('dark', shouldBeDark);
    }
}
